'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxIconStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleIcons = require('reactackle-icons');

var _reactackleCore = require('reactackle-core');

var _CheckboxLabelStyled = require('./CheckboxLabelStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  disabled: _propTypes2.default.bool,
  checked: _propTypes2.default.bool
};

var defaultProps = {
  disabled: false,
  checked: false
};

/* Prop Receivers */
var iconSize = function iconSize(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.checkbox;
  var _path$input = path.input,
      size = _path$input.size,
      borderWidth = _path$input.borderWidth;
  var _path$icon = path.icon,
      imgSize = _path$icon.imgSize,
      iconSize = _path$icon.size;


  var outerSize = 'calc(' + (0, _reactackleCore.getValueString)(size) + ' - ' + borderWidth * 2 + 'px)';

  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)(outerSize, (0, _reactackleCore.getValueString)(imgSize || iconSize), outerSize));
};

var iconPosition = function iconPosition(_ref2) {
  var themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var borderWidth = theme.reactackle.components.checkbox.input.borderWidth;


  return '\n    top: ' + (0, _reactackleCore.getValueString)(borderWidth) + ';\n    left: ' + (0, _reactackleCore.getValueString)(borderWidth) + ';\n  ';
};

var iconStyle = function iconStyle(_ref3) {
  var checked = _ref3.checked,
      disabled = _ref3.disabled,
      themeFromProvider = _ref3.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.checkbox.icon.style;
  var source = checked ? path.checked : path;

  return !disabled ? (0, _styledComponents.css)(['opacity:', ';', ';&:hover,', ':hover &{color:', ';opacity:', ';}&:focus,', ':focus &{color:', ';opacity:', ';}'], source.opacity, (0, _reactackleIcons.iconStyleMixin)(source.color), _CheckboxLabelStyled.CheckboxLabelStyled, source.hover.color, source.hover.opacity, _CheckboxLabelStyled.CheckboxLabelStyled, source.focus.color, source.focus.opacity) : (0, _styledComponents.css)(['&,&:hover,', ':hover &,&:focus,', ':focus &{opacity:', ';', ';}'], _CheckboxLabelStyled.CheckboxLabelStyled, _CheckboxLabelStyled.CheckboxLabelStyled, source.disabled.opacity, (0, _reactackleIcons.iconStyleMixin)(source.color));
};

/* Styles */
var CheckboxIconStyled = exports.CheckboxIconStyled = _styledComponents2.default.div.withConfig({
  displayName: 'CheckboxIconStyled'
})(['position:absolute;z-index:1;', ';', ';', ';', ';&:focus{box-shadow:none;outline:none;}'], iconSize, iconPosition, iconStyle, (0, _reactackleCore.transition)('color, opacity'));

CheckboxIconStyled.propTypes = propTypes;
CheckboxIconStyled.defaultProps = defaultProps;
CheckboxIconStyled.displayName = 'CheckboxIconStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-checkbox/dist/styles/CheckboxIconStyled.js
// module id = 615
// module chunks = 0